//Import for IE  
import 'react-app-polyfill/ie11';
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/map';
import 'core-js/es6/set';
import { con } from './shared/config/config'

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from "react-redux";
import { Router } from 'react-router-dom';
import { history } from './shared/core/history';
import ReactGA from 'react-ga4';
import store from './index-store';
// MSAL imports
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import axios from 'axios';

if ((con.ENVIRONMENT === 'PROD' || con.ENVIRONMENT === 'PRODBLUE') && con.GA_ID_PROD) {
  ReactGA.initialize(con.GA_ID_PROD);
}
else if ((con.ENVIRONMENT === 'QA' || con.ENVIRONMENT === 'QABLUE') && con.GA_ID_QA) {
  ReactGA.initialize(con.GA_ID_QA);
}
else if ((con.ENVIRONMENT === 'DEV' || con.ENVIRONMENT === 'LOCAL') && con.GA_ID_DEV) {
  ReactGA.initialize(con.GA_ID_DEV);
}


if ((con.ENVIRONMENT === 'PROD' && con.GA_ID_PROD) || (con.ENVIRONMENT === 'QA' || con.ENVIRONMENT === 'DEV')) {
  history.listen((location, action) => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  });
}

// Fetch MSAL config from backend and initialize
axios.get("/api/authConfig")
  .then(async res => {
    // Update MSAL config with backend values
    msalConfig.auth.clientId = res.data.CLIENT_ID;
    msalConfig.auth.authority = `https://login.microsoftonline.com/${res.data.TENANT_ID}`;
    // Initialize MSAL instance with fetched config
    const msalInstance = new PublicClientApplication(msalConfig);
    // Make MSAL instance globally available
    (window.globalThis || window).msalInstance = msalInstance;
    // Initialize MSAL, then process any redirect response before rendering.
    // handleRedirectPromise() MUST be called before the first render so that
    // the auth-code / hash returned by Azure AD after loginRedirect() is
    // consumed and the account is placed into the MSAL cache.  Without this,
    // getAllAccounts() returns [] on the post-redirect page load, the app
    // thinks the user is unauthenticated, and the Login page's handleRedirect()
    // fires window.location.href = 'auth-login/...' → infinite reload loop.
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
    ReactDOM.render(
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <Router history={history}>
            <App />
          </Router>
        </Provider>
      </MsalProvider>,
      document.getElementById('root')
    );
  })
  .catch(error => {
    console.error('Failed to load MSAL configuration:', error);
    document.getElementById("root").innerHTML = '<div style="padding: 20px; text-align: center;"><h2>Failed to load authentication configuration</h2><p>Please refresh the page or contact support.</p></div>';
  });
  
// If you want your app to work offline and load faster, you can change 
// unregister() to register() below. Note this comes with some pitfalls. 
// Learn more about service workers: http://bit.ly/CRA-PWA 
serviceWorker.register();

